import { api } from "@/api";

export async function deleteFavoriteSport(id: number) {
  const res = await api.client.delete(`/sports-new/favorite/${id}`);
  return res.data;
}
